import React, { useState, useRef, createRef } from 'react';
import './App.css';
import Buttons from './components/buttons'

const App = () => {
    const [resultatChiffre1, setResultatChiffre1] = useState(null)
    const [resultatSigne, setResultatSigne] = useState(null)
    const [resultatChiffre2, setResultatChiffre2] = useState(null)

    const divAffichage = document.querySelector('.affichageCalcul')
    const newP = document.createElement('p')
    newP.setAttribute('class','loulou')
    const affichageP = document.querySelector('.affichageP')
   
   const handleClick = (event) =>{
      const target = event.target
      const attribut = target.getAttribute('nbr')
     if(resultatSigne === null){
        if(resultatChiffre1 === null){
          setResultatChiffre1(attribut )
        }
        else{
          setResultatChiffre1( resultatChiffre1 + attribut )
        }
     } 
      if (resultatSigne !== null){
        if (resultatChiffre2 === null){
          setResultatChiffre2(attribut)
        }else{
          setResultatChiffre2( resultatChiffre2 + attribut )
        }
  }
}

  const handleClickSign = (event) =>{
    const target = event.target
    const attribut = target.getAttribute('sign')
    setResultatSigne(attribut)
  }
  
   const handleResulat = () =>{
    setResultatChiffre2(null)
    setResultatChiffre1(null)
    setResultatSigne(null)     
      
    if(resultatSigne === '+'){
        newP.innerHTML = parseInt(resultatChiffre1) + parseInt(resultatChiffre2)
        divAffichage.appendChild(newP)
     }else if(resultatSigne === '-'){
        newP.innerHTML = parseInt(resultatChiffre1) - parseInt(resultatChiffre2)
        divAffichage.appendChild(newP)
     }else if(resultatSigne === '*'){
        newP.innerHTML = parseInt(resultatChiffre1) * parseInt(resultatChiffre2)
        divAffichage.appendChild(newP)
     }else if(resultatSigne === '/'){
        newP.innerHTML = parseInt(resultatChiffre1) / parseInt(resultatChiffre2)
        divAffichage.appendChild(newP)
     }
  }
  const handleClean = () =>{
    if(affichageP.nextSibling){
        affichageP.nextSibling.remove()
    }
    setResultatChiffre2(null)
    setResultatChiffre1(null)
    setResultatSigne(null)
  }
   return(
      <div className="App">
          <div className='affichageCalcul'>
             <p className='affichageP'>{resultatChiffre1}{resultatSigne}{resultatChiffre2} </p>
          </div>
        <Buttons
        handleClick = {handleClick}
        handleClean = {handleClean}
        handleResulat = {handleResulat}
        handleClickSign = {handleClickSign}
        />
      </div>
    );
  }

export default App;
